import {addBreadcrumb, captureException} from '@sentry/browser';
import {
  SENTRY_DEDUPE_CACHE_KEY,
  SENTRY_DEDUPE_WINDOW_MS,
} from '../constants/constants';

const safeReadSentryCache = now => {
  try {
    const raw = window.localStorage.getItem(SENTRY_DEDUPE_CACHE_KEY);
    if (!raw) {
      return {expiresAt: now + SENTRY_DEDUPE_WINDOW_MS, seen: {}};
    }

    const parsed = JSON.parse(raw);
    const hasValidShape =
      parsed &&
      typeof parsed === 'object' &&
      typeof parsed.expiresAt === 'number' &&
      parsed.seen &&
      typeof parsed.seen === 'object';

    if (!hasValidShape || parsed.expiresAt <= now) {
      return {expiresAt: now + SENTRY_DEDUPE_WINDOW_MS, seen: {}};
    }

    return parsed;
  } catch (e) {
    return {expiresAt: now + SENTRY_DEDUPE_WINDOW_MS, seen: {}};
  }
};

const safeWriteSentryCache = cache => {
  try {
    window.localStorage.setItem(SENTRY_DEDUPE_CACHE_KEY, JSON.stringify(cache));
  } catch (e) {
    // Ignore localStorage write failures (private mode, quota, etc.).
  }
};

const getSentryEventSignature = event => event?.message || 'unknown-event';

export const shouldDropDuplicateSentryEvent = event => {
  const now = Date.now();
  const cache = safeReadSentryCache(now);
  const signature = getSentryEventSignature(event);

  if (cache.seen[signature]) {
    return true;
  }

  cache.seen[signature] = now;
  safeWriteSentryCache(cache);
  return false;
};

export default class SentryHelper {
  static debugQuantityZero = data => {
    addBreadcrumb({
      category: 'zeroQty',
      message: data.message || 'No message set',
      level: 'info',
    });
    captureException(new Error('Quantity is zero!'));
  };
}
